<template>
  <tr class="grid grid-cols-2 grid-flow-row md:table-row">
    <td
      class="md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
    >
      Customer
    </td>
    <td
      class="px-3 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
    >
      <a
        class="text-blue-500 cursor-pointer"
        @click="$emit('openCustomerInfo', checkout.customer.phoneNumber)"
        >{{ checkout.customer.firstName }} {{ checkout.customer.lastName }}</a
      >
    </td>
    <td
      class="md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
    >
      Created at
    </td>
    <td
      class="px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 text-gray-500"
    >
      {{ checkout.createdDate | dateFilter }}
    </td>
    <td
      class="md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
    >
      Recovery status
    </td>
    <td
      class="px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 text-gray-500"
    >
      <span
        class="px-2 inline-flex text-xs leading-5 font-normal rounded-full"
        :class="{
          'bg-green-100 text-green-800': checkout.isRecovered
        }"
        :style="!checkout.isRecovered ? warningBadgeStyle : null"
      >
        {{ checkout.isRecovered ? "recovered" : "Not recovered" }}
      </span>
    </td>
    <td
      class="md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
    >
      Message status
    </td>
    <td
      class="px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 text-gray-500"
    >
      <span class="flex items-center">
        <span
          class="px-2 inline-flex text-xs leading-5 font-normal rounded-full"
          :class="{
            'bg-green-100 text-green-800': checkout.isMessageSent
          }"
          :style="!checkout.isMessageSent ? warningBadgeStyle : null"
        >
          {{
            checkout.isMessageSent
              ? "Sent"
              : checkout.isSentByAutomation
              ? "Failed"
              : "Not sent"
          }}
        </span>
        <span
          v-if="checkout.reasonForSkipped"
          class="relative inline-block ml-1"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="h-6 w-6 text-gray-500 hover:text-gray-700 cursor-pointer"
            @mouseenter="showPopover = true"
            @mouseleave="showPopover = false"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              style="fill: yellow"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
            />
          </svg>

          <!-- Popover -->
          <div
            v-if="showPopover"
            class="absolute z-10 px-2 py-1 -mt-1 text-sm bg-gray-700 text-white rounded shadow-lg"
            style="left: 100%; margin-left: 4px"
          >
            {{ checkout.reasonForSkipped }}
          </div>
        </span>
      </span>
    </td>
    <td
      class="md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
    >
      Checkout Id
    </td>
    <td
      class="px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
    >
      {{ checkout.checkoutId }}
    </td>
    <td
      class="md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
    >
      Total
    </td>

    <td
      class="px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
    >
      <span>{{ checkout.currency }} {{ checkout.totalPrice }}</span>
      <br />
      <span
        class="text-gray-500"
        v-if="checkout.customerMeta && checkout.customerMeta.lastOrderTime"
        >{{ checkout.customerMeta.lastOrderTime | dateFilter }}</span
      >
      <div v-if="checkout.storeId === '661cd1ef47e9075874dca234'">
        <span
          class="px-2 inline-flex text-xs leading-5 font-normal rounded-full"
          :class="{
            'bg-green-100 text-green-800': checkout.isAcceptsMarketing
          }"
          :style="!checkout.isAcceptsMarketing ? warningBadgeStyle : null"
        >
          {{
            checkout.isAcceptsMarketing
              ? "Opted for messages"
              : "Not opted for messages"
          }}
        </span>
      </div>
      <div
        v-if="
          checkout.storeId === '68095717ffc8b173b6dff278' ||
            checkout.storeId === '68a9f8f10e25c40e3edd1ede'
        "
      >
        <span
          class="px-2 inline-flex text-xs leading-5 font-normal rounded-full"
          :class="{
            'bg-green-100 text-green-800': checkout.messageSentTime
          }"
          :style="!checkout.messageSentTime ? warningBadgeStyle : null"
        >
          {{ checkout.messageSentTime ? "Manually sent" : "" }}
        </span>
      </div>
    </td>
    <td
      class="md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
    ></td>
    <td
      class="px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
    >
      <div class="mt-2">
        <span
          v-if="checkout.customerMeta && checkout.customerMeta.shouldNotDisturb"
          class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-indigo-100 text-indigo-800"
        >
          Do not disturb
          <button
            type="button"
            class="flex-shrink-0 ml-1.5 inline-flex text-indigo-500 focus:outline-none focus:text-indigo-700"
            aria-label="Remove small badge"
            @click="removeTag('shouldNotDisturb')"
          >
            <svg
              class="h-2 w-2"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 8 8"
            >
              <path
                stroke-linecap="round"
                stroke-width="1.5"
                d="M1 1l6 6m0-6L1 7"
              />
            </svg>
          </button>
        </span>
        <span
          v-if="checkout.customerMeta && checkout.customerMeta.isNotOnWhatsapp"
          class="inline-flex mx-1 items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-indigo-100 text-indigo-800"
        >
          Not on Whatsapp
          <button
            type="button"
            class="flex-shrink-0 ml-1.5 inline-flex text-indigo-500 focus:outline-none focus:text-indigo-700"
            aria-label="Remove small badge"
            @click="removeTag('isNotOnWhatsapp')"
          >
            <svg
              class="h-2 w-2"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 8 8"
            >
              <path
                stroke-linecap="round"
                stroke-width="1.5"
                d="M1 1l6 6m0-6L1 7"
              />
            </svg>
          </button>
        </span>
      </div>

      <div class="mt-2">
        <AddTagDropdown @onItemClicked="addTag" />
      </div>
    </td>
    <td
      class="px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap text-right border-b border-gray-200 text-xs leading-5 font-medium"
    >
      <SendMessageDropdown :checkout="checkout" v-if="!checkout.isRecovered" />
    </td>
  </tr>
</template>

<script>
import SendMessageDropdown from "./SendMessageDropdown";
import AddTagDropdown from "./AddTagDropdown";

import { format } from "date-fns";

export default {
  name: "CartListItem",
  components: {
    SendMessageDropdown,
    AddTagDropdown
  },
  data() {
    return {
      showPopover: false,
      warningBadgeStyle: {
        backgroundColor: "#f3c989",
        color: "#5b3a08"
      }
    };
  },
  props: {
    checkout: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  filters: {
    dateFilter(value) {
      return format(new Date(value * 1000), "h:mm a, MMM dd");
    }
  },
  methods: {
    addTag(tag) {
      const obj = {};
      obj[tag] = true;
      this.$store.dispatch("updateTag", {
        requestParams: obj,
        checkoutId: this.checkout.id
      });
      this.$emit("refreshCurrentPage");
    },
    removeTag(tag) {
      const obj = {};
      obj[tag] = false;
      this.$store.dispatch("updateTag", {
        requestParams: obj,
        checkoutId: this.checkout.id
      });
      this.$emit("refreshCurrentPage");
    }
  }
};
</script>

<style lang="scss" scoped></style>
